var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"nav_tit"},[_c('img',{attrs:{"src":require("@/assets/images/navtitle.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }